import axios from 'axios';
import { axiosConfig } from '@/config/axiosConfig.js';

export const station_history_ajax = (client_name, params) => {
    return axios.post(`${client_name}/rainmonitor/get_station_history_data/`, params, axiosConfig)
}

export const weather_station_history_data = (client_name, params) => {
    return axios.post(`${client_name}/rainmonitor/get_weather_station_history_data/`, params, axiosConfig)
}

export const get_stations_history_params = function (current_row_data) {
    const base_params = {
        station_code: current_row_data[this.$t('__chart_common.station_code_key')],
        data_time: `${this.date} ${this.time}:00`,
        lang: this.language,
    }

    // 357(堰塞湖集水區降雨量估計) 沒有站號，用英文名稱查歷史資料
    if (this.default_value === 357) {
        return {
            ...base_params,
            station_code: current_row_data['英文名稱'],
            data_type: 'qpenameonly',
        }
    }

    return base_params
}

export const get_station_history = async (client_name, params) => {
    try {
        const res = await station_history_ajax(client_name, params)
        return res.data.data
    } catch (error) {
        console.error(error)
    }
}

// 集水區估計雨量(qpenameonly)後端回傳的時距 key 是中文，且沒有折線用的累積雨量資料，轉成 GisChart 期待的格式
const RAIN_LABEL_TO_KEY = {
    '10分鐘': 'min_10',
    '1小時': 'hr_1',
    '3小時': 'hr_3',
    '6小時': 'hr_6',
    '12小時': 'hr_12',
    '24小時': 'hr_24',
    '48小時': 'hr_48',
    '72小時': 'hr_72',
}

const normalize_qpenameonly_data = (data) => {
    const remapped = Object.entries(data).reduce((accumulator, [key, value]) => {
        const mapped_key = RAIN_LABEL_TO_KEY[key]
        return { ...accumulator, [mapped_key || key]: value }
    }, {})

    // 空陣列讓 GisChart 直接跳過累積雨量折線的繪製與 tooltip 顯示
    for (let day = 1; day <= 6; day++) {
        remapped[`cumulative_rainfall_${day}_day`] = []
    }

    return remapped
}

export const fetch_station_time_series_data = async (chart_options) => {
    const {
        type: gis_sub_type,
        client_name,
        ...input_params
    } = chart_options

    const AJAX_MAPPING = {
        gauge: (() => station_history_ajax(client_name, input_params))(),
        weather: (() => weather_station_history_data(client_name, input_params))()
    }

    const requests = Object.keys(gis_sub_type).reduce((accumulator, type) => {
        return AJAX_MAPPING[type] ? [...accumulator, ...[AJAX_MAPPING[type]]] : accumulator
    }, [])

    const responses = await Promise.all(requests)
    const is_all_response_success = responses.every(response => response.data.status === 'success')
    if (!is_all_response_success) {
        throw responses.find(response => response.data.status !== 'success')
    }

    const combine_response_object = (accumulator, res) => {
        return res.data.status === 'success' ? { ...accumulator, ...res.data.data } : accumulator
    }
    const combined_data = responses.reduce(combine_response_object, {})

    return input_params.data_type === 'qpenameonly' ? normalize_qpenameonly_data(combined_data) : combined_data
}

export const get_all_station_history = async (client_name, params) => {
    const requests = [
        (() => station_history_ajax(client_name, params))(),
        (() => weather_station_history_data(client_name, params))()
    ]

    try {
        const responses = await Promise.all(requests)
        return responses.reduce((accumulator, res) => {
            if (res.data.status === 'success') {
                return { ...accumulator, ...res.data.data }
            }
        }, {})
    } catch(error) {
        console.error(error);
    }
}